import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {ManagerFormValuesProps} from "../components/shopManagers/NewShopManagerModal";
import {BlackoutDateProps} from "../types/BlackoutPeriod";

export const renameFlow = async (domain: string, flowId: number, newName: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `flows/${flowId}/rename`,
        method: 'PATCH',
        headers: {
            "Content-Type": "application/json",
        },
        params: {
            title: newName,
        },
        domain,
    });
}